import * as React from 'react'

export function CaretDownIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26 12L16 22L6 12" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
